module.exports = __webpack_public_path__ + "img/main-clouds.3aeefd0e.png";